<script lang="ts">
	import classNames from 'classnames';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { ShopRoutes } from '#lib/websites/shop/constants/routes.js';
	import { ChevronRightIcon } from '$global/assets/icons/ChevronRightIcon';
	import HeniShopLogo from '$global/assets/logos/HeniShopLogo/HeniShopLogo.svelte';
	import { Button } from '$global/components/Button';
	import { Txt } from '$global/components/Txt';

	const dataCy = 'home-shop';

	const CARDS = [
		{
			label: 'Books',
			href: ShopRoutes.Books,
			image: '/img-svelte/shop/shop-books-bg.jpg',
			dataCy: 'shop-books',
		},
		{
			label: 'Apparel',
			href: `${ShopRoutes.Merch}/apparel`,
			image: '/img-svelte/shop/shop-apparel-bg.png',
			dataCy: 'shop-apparel',
		},
		{
			label: 'Posters',
			href: `${ShopRoutes.Merch}/posters`,
			image: '/img-svelte/shop/shop-posters-bg.webp',
			dataCy: 'shop-posters',
		},
		{
			label: 'Accessories',
			href: `${ShopRoutes.Merch}/accessories`,
			image: '/img-svelte/shop/shop-accessories-bg.webp',
			dataCy: 'shop-accessories',
		},
	];
</script>

<section class="flex-col">
	<div class="mb-6 flex items-start justify-between">
		<div>
			<HeniShopLogo class="mb-2 w-[160px]" />
			<Txt variant="body2">
				Books, posters, and merch connected to HENI releases and artists.
			</Txt>
		</div>

		<a
			data-cy={`${dataCy}-view-all-artists-top`}
			href={GlobalRoutes.ShopHome}
			class="hidden md:block"
		>
			<Button
				dataCy={`${dataCy}-view-all-artists-top`}
				variant="secondary"
				size="md"
			>
				Shop all

				{#snippet trailing()}
					<ChevronRightIcon />
				{/snippet}
			</Button>
		</a>
	</div>

	<div class="grid grid-cols-4 border border-gray-400">
		{#each CARDS as card, index}
			<a
				aria-label={card.label}
				href={card.href}
				data-cy={card.dataCy}
				class={classNames(
					'relative col-span-2 border-gray-400 pt-[100%] md:pt-[50%] lg:col-span-1 lg:pt-[100%]',
					{
						'lg:border-r lg:border-b-0':
							index === 0 || index === 1 || index === 2,
						'border-r': index === 0 || index === 2,
						'border-b': index === 0 || index === 1,
					}
				)}
			>
				<div
					class="absolute top-0 h-full w-full bg-cover bg-bottom md:bg-contain md:bg-no-repeat lg:bg-cover"
					style={`background-image: url(${card.image})`}
				></div>
				<div
					class="absolute top-0 h-full w-full bg-gray-900 opacity-20 transition-opacity duration-300 hover:opacity-10"
				></div>

				<Txt
					variant="h6"
					class="text-gray-0 xs:text-[25px] absolute bottom-0 p-2 text-[5.3cqw] font-[600] uppercase sm:p-4 sm:text-[28px] lg:text-[28px] xl:text-[33px]"
				>
					{card.label}
				</Txt>
			</a>
		{/each}
	</div>

	<div class="mt-6 sm:flex sm:justify-end md:hidden">
		<a data-cy={`${dataCy}-shop-all-bottom`} href={GlobalRoutes.ShopHome}>
			<Button
				dataCy={`${dataCy}-shop-all-bottom`}
				variant="secondary"
				size="md"
				class="w-full sm:w-auto"
			>
				Shop all

				{#snippet trailing()}
					<ChevronRightIcon />
				{/snippet}
			</Button>
		</a>
	</div>
</section>
